import * as actions from './clearUserActions';

const clearUserReducer = {
  [actions.USER_CLEAR_USER]: () => {
    return {};
  },
};

export default clearUserReducer;
